<template>
  <div class="criterio-ticket-range">
    <span class="criterio-subtitle">{{ label }}</span>

    <v-layout class="container-cumpon-range">
      <v-flex class="d-flex" cols="12" sm="12">
        <p>
          <!-- v-money and v-mask doesn't work together. Also, if v-mask is a nullable value it doen't work. So I did 2 differents v-text-field -->
          <span> de </span>
          <v-text-field
            v-if="isMoney"
            ref="firstValue"
            v-model.lazy="firstValue"
            v-money="money"
            :disabled="disabled"
            prefix="R$"
            outlined
            hide-details
            :maxlength="10"
            :suffix="suffix"
            @keypress="isNumber"
          />
          <v-text-field v-else v-model="firstValue" v-mask="inputMask" :disabled="disabled" outlined hide-details @keypress="isNumber" />
        </p>
        <p>
          <span> até </span>
          <v-text-field
            v-if="isMoney"
            ref="secondValue"
            v-model.lazy="secondValue"
            v-money="money"
            :disabled="disabled"
            prefix="R$"
            outlined
            hide-details
            :maxlength="10"
            :suffix="suffix"
            @keypress="isNumber"
          />
          <v-text-field v-else v-model="secondValue" v-mask="inputMask" :disabled="disabled" outlined hide-details @keypress="isNumber" />
        </p>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { VMoney } from 'v-money'
export default {
  directives: { money: VMoney },
  props: {
    label: String,
    currentIndex: Number,
    initialValue: {},
    values: {},
    componentParams: String,
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    firstValue: null,
    secondValue: null,
    timeout: null,
    money: {
      decimal: ',',
      thousands: '.',
      precision: 2,
      masked: false,
    },
  }),

  computed: {
    inputMask() {
      if (['age', 'percentage'].includes(this.componentParams)) return '###'
      else return '########'
    },
    isMoney() {
      return this.componentParams === 'money'
    },
    suffix() {
      if (this.componentParams === 'percentage') return '%'
      return ''
    },
  },

  watch: {
    firstValue() {
      this.debouncedEmitValues()
    },
    secondValue() {
      this.debouncedEmitValues()
    },
  },

  mounted() {
    this.getData()
  },

  methods: {
    hasValue(value) {
      return typeof value === 'string' && value !== ''
    },

    getNumberByStr(value) {
      let newValue = value
      if (!value) return 0
      newValue = String(value).split('.').join('').split(',').join('.')
      return Number(newValue.replace(/[^0-9-.]/g, '')) > 0 ? Number(newValue.replace(/[^0-9.]/g, '')) : 0
    },

    debouncedEmitValues() {
      window.clearTimeout(this.timeout)
      this.timeout = window.setTimeout(() => {
        this.emitValues()
      }, 500)
    },

    emitValues() {
      this.$emit('input', { currentValue: [this.getNumberByStr(this.firstValue), this.getNumberByStr(this.secondValue)], currentIndex: this.currentIndex })
      this.validate()
    },

    async validate() {
      this.$emit('validate', { isValid: await this.isValid(), currentIndex: this.currentIndex })
    },

    isValid() {
      if (!this.hasValue(this.firstValue) || !this.hasValue(this.secondValue)) return false
      return this.getNumberByStr(this.firstValue) <= this.getNumberByStr(this.secondValue)
    },

    isNumber(evt) {
      evt = evt || window.event
      const charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault()
      }
    },

    getData() {
      if (this.initialValue) {
        if (this.isMoney) {
          this.$refs.firstValue.$el.getElementsByTagName('input')[0].value = this.initialValue[0].toFixed(2)
          this.$refs.secondValue.$el.getElementsByTagName('input')[0].value = this.initialValue[1].toFixed(2)
        } else {
          this.firstValue = this.initialValue[0]
          this.secondValue = this.initialValue[1]
        }
      }
      this.validate()
    },
  },
}
</script>

<style lang="scss">
.criterio-ticket-range {
  margin-top: 24px;

  .criterio-subtitle {
    font-size: 16px;
  }

  .container-cumpon-range {
    margin-top: 10px;

    p:nth-child(1) {
      margin-right: 15px;
    }
  }
}
</style>
